import RelationshipMetadata from "../../RelationshipMetadata";

class ProjectPlanProjectPlanAuditLogRelationshipMetadata extends RelationshipMetadata {
    constructor() {
        super();

        this.name = "ProjectPlanProjectPlanAuditLog";
        this.parentEnterpriseComponent = "ProjectPlan";
        this.childEnterpriseComponent = "ProjectPlanAuditLog";
        this.sourceAttribute = "USID";
        this.destinationAttribute = "ProjectPlanUSID";
    }
}

export default ProjectPlanProjectPlanAuditLogRelationshipMetadata;